<template>
  <div id="why-section" class="why-section container">
    <div class="why-section__icon">
      <why-use-icon />
    </div>
    <div class="why-section__title">Why use Commerce Co.?</div>
    <div class="why-section__description">Working with Commerce Co. is the equivalent to having global operations in major countries such as Asia, Europe, and the U.S. We have boots on the ground working with factories to source, produce and ship products worldwide. You can focus on growing your business while we focus on producing and delivering products to your customers.</div>
    <div class="why-section__content">
      <div class="why-section__image-wrap">
        <img
          src="/static/images/life-circle.png"
          class="why-section__image"
        >
      </div>
      <ul class="why-section__list">
        <li class="why-section__list-item">
          <div class="why-section__list__title">ALL IN ONE</div>
          <div class="why-section__list__content">Product sourcing, shipping, and fullfilment with costs as close to manufacturing rates as possible</div>
        </li>
        <li class="why-section__list-item">
          <div class="why-section__list__title">SUPER FAST SHIPPING</div>
          <div class="why-section__list__content">As fast as next day to 2-3 days delivery from our U.S. shipping center</div>
        </li>
        <li class="why-section__list-item">
          <div class="why-section__list__title">LOWER RISK</div>
          <div class="why-section__list__content">Eliminate risk from dealing with multiple suppliers</div>
        </li>
        <li class="why-section__list-item">
          <div class="why-section__list__title">PRODUCTION INSPECTION</div>
          <div class="why-section__list__content">Certified inspection of your product</div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import WhyUseIcon from 'static/assets/icons/WhyUseIcon.svg'

export default {
  name: 'WhySection',
  components: {
    WhyUseIcon,
  },
}
</script>

<style lang="sass" scoped>
@import '~styles/shared'

.why-section
  max-width: 1096px
  margin: 46px auto 66px

  @include tablet
    margin-bottom: 39px

  @include widescreen
    margin-bottom: 45px

.why-section__icon
  width: 57px
  height: 51px
  margin: 0 auto
  position: relative
  top: -7px
  left: -9px

.why-section__title
  text-align: center
  font-size: 27px
  font-weight: 600
  line-height: 32px
  padding: 18px 0
  color: #1d3762

  @include tablet
    font-size: 34px
    padding-top: 22px
    padding-bottom: 21px

  @include widescreen
    padding-bottom: 31px

.why-section__description
  text-align: center
  line-height: 28px
  margin-top: 3px
  color: #525f7f

  @include tablet
    font-size: 18px
    padding: 0 60px
    letter-spacing: .3px
    line-height: 31px

  @include widescreen
    max-width: 805px
    margin: 0 auto

.why-section__content
  @include tablet
    display: flex
    padding-left: 12px
    padding-right: 12px
    padding-top: 60px

  @include widescreen
    padding-top: 64px

.why-section__image-wrap
  padding: 28px 15px 0
  position: relative
  text-align: center
  max-width: 350px
  margin: 0 auto

  @include tablet
    padding-right: 0
    flex-shrink: 0
    max-width: 67%
    margin: -80px -34px -74px -80px

  @include widescreen
    max-width: 724px
    padding-right: 0
    margin: -80px -34px -74px -105px

.why-section__image
  width: 100%
  max-width: 100%

.why-section__list
  position: relative
  z-index: 1

  @include widescreen
    margin-top: 38px

.why-section__list-item
  margin-bottom: 42px

.why-section__list__title
  color: #06a978
  text-transform: uppercase
  font-size: 17px
  font-weight: 500
  padding-bottom: 4px

.why-section__list__content
  color: #525f7f
  font-size: 18px
  line-height: 29px
  letter-spacing: .2px

  @include widescreen
    padding-right: 40px
</style>



// WEBPACK FOOTER //
// src/WhySection.vue